import * as React from "react";
import {IconProps, getIconSize} from "./IconInterface"

export const IconBrush = ({
  className,
  size = "md"
}: IconProps) => {
  const sizeOption = getIconSize(size)
  return (
    <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    className={`${className} ${sizeOption}`}
  >
    <defs>
      <path
        d="M17.7656,7.3926 L11.8986,13.2576 C11.7476,13.0316 11.5746,12.8176 11.3776,12.6216 C11.1806,12.4246 10.9666,12.2526 10.7406,12.1046 L16.6096,6.2376 C16.9156,5.9306 17.4576,5.9296 17.7666,6.2386 C17.9196,6.3916 18.0026,6.5916 17.9996,6.8276 C18.0026,7.0386 17.9186,7.2386 17.7656,7.3926 M8.2456,17.9406 L6.0176,17.9816 L6.0566,15.7506 C6.0776,14.4846 7.1266,13.4346 8.3956,13.4126 C8.4096,13.4126 8.4216,13.4116 8.4356,13.4116 C9.0196,13.4116 9.5606,13.6316 9.9636,14.0356 C10.3766,14.4476 10.5976,15.0036 10.5876,15.6016 C10.5666,16.8696 9.5156,17.9186 8.2456,17.9406 M19.9996,6.8276 C20.0096,6.0716 19.7176,5.3596 19.1806,4.8236 C18.1186,3.7626 16.2556,3.7596 15.1956,4.8236 L8.5826,11.4336 C8.5076,11.4296 8.4356,11.4136 8.3606,11.4126 C6.0266,11.4546 4.0956,13.3856 4.0566,15.7166 L3.9996,18.9826 C3.9946,19.2536 4.1016,19.5156 4.2926,19.7066 C4.4806,19.8946 4.7356,19.9996 4.9996,19.9996 L5.0186,19.9996 L8.2846,19.9406 C10.6166,19.8996 12.5466,17.9686 12.5876,15.6356 C12.5886,15.5606 12.5726,15.4896 12.5706,15.4136 L19.1796,8.8066 C19.7176,8.2686 20.0096,7.5566 19.9996,6.8276"
        id="path-ass-5k-7a2-1"
      />
    </defs>
    <g
      id="\u2B50\uFE0F-[Symbols]-Icons"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icon/brush">
        <mask id="mask-ass-5k-7a2-2" fill="white">
          <use xlinkHref="#path-ass-5k-7a2-1" />
        </mask>
        <use
          id="\uD83C\uDFA8-Icon-\u0421olor"
          fill="#1C1F2B"
          xlinkHref="#path-ass-5k-7a2-1"
        />
      </g>
    </g>
  </svg>
  )
}
